import React from 'react';
import { Phone, Mail } from 'lucide-react';

export default function ProposalHeader({ proposal }) {
  return (
    <div className="px-6 pt-2 pb-3 border-b border-slate-200">
      <div className="flex items-center justify-between">
        {/* Logo - Left, moved up */}
        <div className="flex-shrink-0 -mt-2">
          <img
            src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69b5afabd540121a86879b5b/e29b4c6b2_CLLLogoTransparent.png"
            alt="Center Line Locating"
            className="h-24 w-auto object-contain"
          />
        </div>
        
        {/* Address Info - Center/Right (Physical address removed per request) */}
        <div className="flex-1 min-w-0 text-center px-4">
          <p className="text-[12px] text-slate-700 font-medium">PO Box 38251, Charlotte, NC 28278</p>
          <div className="flex items-center justify-center gap-4 mt-1 text-[11px] text-slate-500 flex-nowrap">
            <span className="flex items-center gap-1 whitespace-nowrap"><Phone className="w-3 h-3" />(704) 315-5820</span>
            <span className="flex items-center gap-1 whitespace-nowrap"><Mail className="w-3 h-3" />requests@cllocating.com</span>
          </div>
        </div>
        
        {/* Proposal Number - Right */}
        <div className="text-right flex-shrink-0">
          <p className="text-[10px] text-slate-400 uppercase tracking-wider">Proposal</p>
          <p className="text-lg font-bold text-slate-800">#{proposal.proposal_number || 'Draft'}</p>
        </div>
      </div>
    </div>
  );
}
